module.exports = __webpack_public_path__ + "img/boaz.92caf3d6.webp";